<template>
  <div>

      <iframe src="https://docs.google.com/document/d/e/2PACX-1vRAzSYFA-scbWRFsPm2yhz30w30mBgdq4Zgqa7hLrbCAzsS9jDiJhis41VoAZ6jWoknozrChDJbB0UT/pub?embedded=true" width="100%" height="650px"></iframe>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>